import { Spinner, SpinnerProps } from '@chakra-ui/react'
import { CenterFlex, CenterFlexGap } from '@root/components/dashboard/chat/style'

export const CustomLoader = ({ ...props }: SpinnerProps) => {
    return (
        <CenterFlexGap minH={'100%'}>
            <Spinner
                color="theme.button.primary"
                margin={'auto'}
                mt={'auto'}
                width={'50px'}
                height={'50px'}
                marginTop={'35vh'}
                {...props}
            />
        </CenterFlexGap>
    )
}
